const GG_PROFESORES_VARIANT_IDS = new Set(["41763429449793","41763458416705","41763465461825","41763466379329","41763466412097","41763466707009","41763467100225"]);

let ggProfesoresNoticeAcceptedInMemory = false;

function ggIsProfesoresPreorder(form) {
  const variantId = form?.querySelector('[name="id"]')?.value;
  return GG_PROFESORES_VARIANT_IDS.has(String(variantId || ''));
}

function ggProfesoresNoticeAccepted() {
  if (ggProfesoresNoticeAcceptedInMemory) return true;
  try {
    return sessionStorage.getItem('gg-profesores-entrega-14-oct-ack') === '1';
  } catch (e) {
    return false;
  }
}

function ggAcceptProfesoresNotice() {
  ggProfesoresNoticeAcceptedInMemory = true;
  try {
    sessionStorage.setItem('gg-profesores-entrega-14-oct-ack', '1');
  } catch (e) {}
}

function ggEnsureProfesoresNoticeStyles() {
  if (document.getElementById('gg-profesores-notice-styles')) return;
  const style = document.createElement('style');
  style.id = 'gg-profesores-notice-styles';
  style.textContent = `
    .gg-profesores-inline-notice{margin:0 0 14px;padding:14px 16px;border:1px solid rgba(31,41,55,.14);border-radius:12px;background:#fff8e8;color:#202020;font-size:14px;line-height:1.45}
    .gg-profesores-inline-notice strong{display:block;margin-bottom:4px;font-size:14px}
    .gg-profesores-modal[hidden]{display:none!important}
    .gg-profesores-modal{position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,.55)}
    .gg-profesores-modal__card{width:min(100%,520px);max-height:calc(100vh - 40px);overflow:auto;padding:24px;border-radius:16px;background:#fff;color:#1f1f1f;box-shadow:0 18px 60px rgba(0,0,0,.22)}
    .gg-profesores-modal__card h2{margin:0 0 10px;font-size:22px;line-height:1.2}
    .gg-profesores-modal__card p{margin:0 0 12px;font-size:15px;line-height:1.5}
    .gg-profesores-modal__details{margin:14px 0 18px;padding:14px;border-radius:12px;background:#f6f6f6}
    .gg-profesores-modal__details p{margin:0 0 8px}.gg-profesores-modal__details p:last-child{margin-bottom:0}
    .gg-profesores-modal__actions{display:grid;gap:10px}
    .gg-profesores-modal__confirm,.gg-profesores-modal__cancel{width:100%;min-height:48px;border-radius:10px;font:inherit;font-weight:700;cursor:pointer}
    .gg-profesores-modal__confirm{border:0;background:#111;color:#fff}
    .gg-profesores-modal__cancel{border:1px solid #d8d8d8;background:#fff;color:#222}
    @media(max-width:749px){.gg-profesores-modal{align-items:flex-end;padding:12px}.gg-profesores-modal__card{padding:20px;border-radius:16px 16px 12px 12px}.gg-profesores-modal__card h2{font-size:20px}}
  `;
  document.head.appendChild(style);
}

function ggMountProfesoresInlineNotice(productForm) {
  if (!productForm || productForm.closest('.card-wrapper') || productForm.closest('quick-add-modal')) return;
  if (productForm.querySelector('.gg-profesores-inline-notice')) return;
  ggEnsureProfesoresNoticeStyles();
  const notice = document.createElement('div');
  notice.className = 'gg-profesores-inline-notice';
  notice.setAttribute('role','note');
  notice.innerHTML = '<strong>⚠️ Importante · Día del Profesor</strong>Por alta demanda, los <b>despachos de productos Profesores serán desde el 14 de octubre</b>.<br>📍 <b>Retiro en fábrica disponible desde hoy si compras hoy</b>, en Caupolicán 1256, Peñalolén, Región Metropolitana.';
  productForm.prepend(notice);
}

function ggShowProfesoresNotice(onConfirm) {
  ggEnsureProfesoresNoticeStyles();
  let modal = document.getElementById('gg-profesores-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'gg-profesores-modal';
    modal.className = 'gg-profesores-modal';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="gg-profesores-modal__card" role="dialog" aria-modal="true" aria-labelledby="gg-profesores-modal-title">
        <h2 id="gg-profesores-modal-title">⚠️ Importante antes de agregar</h2>
        <p>La colección de Profesores tuvo mucha más demanda de la esperada y estamos reponiendo unidades.</p>
        <div class="gg-profesores-modal__details">
          <p>🚚 <b>Despachos:</b> los pedidos que incluyan estos productos comenzarán a salir desde el <b>14 de octubre</b>.</p>
          <p>📍 <b>Retiro en fábrica:</b> disponible <b>desde hoy si compras hoy</b>, en <b>Caupolicán 1256, Peñalolén, Región Metropolitana</b>.</p>
        </div>
        <p>Si lo necesitas antes del 14, elige <b>retiro en fábrica</b> al comprar.</p>
        <div class="gg-profesores-modal__actions">
          <button type="button" class="gg-profesores-modal__confirm">Entiendo, agregar al carrito</button>
          <button type="button" class="gg-profesores-modal__cancel">Volver</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', event => {
      if (event.target === modal || event.target.closest('.gg-profesores-modal__cancel')) {
        modal.hidden = true;
        document.body.style.removeProperty('overflow');
      }
    });
  }
  const confirmButton = modal.querySelector('.gg-profesores-modal__confirm');
  const newButton = confirmButton.cloneNode(true);
  confirmButton.replaceWith(newButton);
  newButton.addEventListener('click', () => {
    ggAcceptProfesoresNotice();
    modal.hidden = true;
    document.body.style.removeProperty('overflow');
    if (typeof onConfirm === 'function') onConfirm();
  }, {once:true});
  modal.hidden = false;
  document.body.style.overflow = 'hidden';
  newButton.focus();
}

 if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.isProfesoresPreorder = ggIsProfesoresPreorder(this.form);
      if (this.isProfesoresPreorder) ggMountProfesoresInlineNotice(this);
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (ggIsProfesoresPreorder(this.form) && !ggProfesoresNoticeAccepted()) {
        ggShowProfesoresNotice(() => this.form.requestSubmit(this.submitButton));
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
